/// <reference types="@angular/localize" />

import {enableProdMode, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {environment} from './environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS} from '@angular/common/http';
import {provideRouter} from '@angular/router';
import {provideToastr, ToastNoAnimation} from 'ngx-toastr';
import {NgbActiveModal, NgbDateAdapter, NgbTimeAdapter} from '@ng-bootstrap/ng-bootstrap';
import {DatePickerStringAdapter} from './app/classes/adapters/datePickerStringAdapter';
import {TimePickerStringAdapter} from './app/classes/adapters/timePickerStringAdapter';
import {AuthInterceptorService} from './app/auth/auth-interceptor.service';
import {
  GoogleLoginProvider,
  SOCIAL_AUTH_CONFIG,
  SocialAuthServiceConfig,
  SocialLoginModule
} from '@abacritt/angularx-social-login';
import {DataService} from './app/services/store/data.service';
import {HttpClientInMemoryWebApiModule} from 'angular-in-memory-web-api';
import {InMemoryDataService} from './app/services/in-memory-data/in-memory-data.service';
import {MockSocialLoginModule} from './app/util/TestUtils';
import {routes} from './app/app.routes';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideToastr({toastComponent: ToastNoAnimation}),
    provideHttpClient(withInterceptorsFromDi()),

    DataService,
    NgbActiveModal,

    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},
    {provide: NgbDateAdapter, useClass: DatePickerStringAdapter},
    {provide: NgbTimeAdapter, useClass: TimePickerStringAdapter},
    provideCharts(withDefaultRegisterables()),
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleClientId, {oneTapEnabled: false})
          }
        ],
      } as SocialAuthServiceConfig
    },

    ...(environment.useInMemory
            ? [
              importProvidersFrom(
                      HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, {
                        dataEncapsulation: false,
                        passThruUnknownUrl: true,
                        delay: 800
                      })
              )
            ]
            : []),

    ...(environment.useInMemory
            ? [importProvidersFrom(MockSocialLoginModule)]
            : [importProvidersFrom(SocialLoginModule)]),
  ]
}).catch(err => console.error(err));